/* eslint-disable max-nested-callbacks */
import { Card, CardContent, Grid2, Stack } from '@mui/material'
import CampaignAction from 'campaign/actions/CampaignAction'
import DtoCampaignFile from 'campaign/dto/DtoCampaignFile'
import Input from 'components/forms/Input'
import ExportFileModal from 'components/modal/ExportFileModal'
import ProgressBar from 'components/progress/ProgressBar'
import ExportAction from 'export/actions/ExportAction'
import { differenceBy, orderBy, uniqBy, split } from 'lodash'
import PropTypes from 'prop-types'
import QualityAction from 'quality/actions/QualityAction'
import React, { useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import FractionAction from 'referencial/components/fraction/actions/FractionAction'
import SupportAction from 'referencial/components/support/actions/SupportAction'
import UnitAction from 'referencial/components/unit/actions/UnitAction'
import { nbPerPageLabel } from 'referencial/constants/ReferencialConstants'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import useActions from 'utils/customHook/useActions'
import useBoolean from 'utils/customHook/useBoolean'
import useProgressDispatch from 'utils/customHook/useProgressDispatch'
import useTitle from 'utils/customHook/useTitle'
import { getFullDate } from 'utils/DateUtil'
import { formatData } from 'utils/ExportDataUtil'
import { getExecStatusIcon, getExecStatusLabel } from 'utils/JobUtils'
import { hasValue } from 'utils/NumberUtil'
import { searchAllCharacters } from 'utils/StringUtil'
import QualityIntegrationOverviewAction from '../integrationOverview/actions/QualityIntegrationOverviewAction'
import OperationAction from '../operation/actions/OperationAction'
import { useParams } from 'react-router'
import AnalysisAction from 'quality/actions/AnalysisAction'
import { arrayLightToObject } from 'utils/ActionUtils'
import useAbortController from 'utils/customHook/useAbortController'
import { CardUpdateAnalysis, ControlForm, ControlTable, HEADER_CONFORM, HEADER_NON_CONFORM } from '../control/ControlAnalysis'
import { CardTitle } from 'components/card/NewCard'
import { CardTable, SORT } from 'components/datatable/NewTable'
import useUpdateEffect from 'utils/customHook/useUpdateEffect'
import MessageCard from 'components/card/MessageCard'
import { calculateThresholdsResult } from 'utils/QualityThresholdUtils'
import JobAction from 'import/actions/JobAction'

const LIST = 'LIST'
const DETAIL = 'DETAIL'

const List = ({
    campaignFiles = [],
    setPanel = () => { },
    setFile = () => { },
}) => {
    const {
        edilaboFiles,
    } = useSelector(store => ({
        edilaboFiles: store.CampaignReducer.edilaboFiles,
    }), shallowEqual)

    const dispatch = useDispatch()

    const {
        value: isExportModalOpen,
        setTrue: openExportModal,
        setFalse: closeExportModal,
    } = useBoolean(false)

    useActions(() => ({
        exportList: [{
            onClick: openExportModal,
            label: i18n.excel,
        }],
    }), [])

    const filesFormated = campaignFiles.map(file => {
        const objExecution = { status: file.statusCode, date: file.date }
        const tooltipStatus = getExecStatusLabel(objExecution)
        return {
            fileLabel: file.nameFile,
            jobExecutionId: file.jobExecutionId,
            date: getFullDate(file.date),
            state: getExecStatusIcon(objExecution, 30, tooltipStatus),
            stations: file.nbStation,
            operations: file.nbOperation,
            analysis: file.nbAnalyse,
            parameters: file.nbParameter,
            nullValue: <i className='material-icons medium clickable' style={{ fontSize: '30px' }} onClick={() => {
                setPanel(DETAIL)
                setFile(file)
            }}
            >offline_pin</i>,
            timestamp: file.date,
        }
    })

    const edilaboFilesFormatted = edilaboFiles.map(file => ({
        fileLabel: file.label,
        date: getFullDate(file.updateDate),
        link: file.href,
    }))

    return (
        <Stack spacing={1}>
            <CardTable
                title={i18n.importedFiles}
                rows={orderBy(filesFormated, 'timestamp', 'desc')}
                headers={['fileLabel', 'date', 'jobExecutionId', 'state', 'stations', 'operations', 'analysis', 'parameters', 'nullValue']}
                rowsPerPageOptions={nbPerPageLabel}
            />
            <CardTable
                title={i18n.qualitoDemandes}
                rows={orderBy(edilaboFilesFormatted, 'updateDate', 'desc')}
                headers={['fileLabel', 'date']}
                rowsPerPageOptions={nbPerPageLabel}
                defaultSort={{ column: 'date', direction: SORT.DESC }}
                lineActions={[
                    {
                        icon: 'download',
                        onClick: (file) => dispatch(JobAction.downloadFile(file.fileLabel, split(file.link, 'contents/')[1])),
                    },
                ]}
            />
            <ExportModal
                campaignFiles={campaignFiles}
                open={isExportModalOpen}
                onClose={closeExportModal}
            />
        </Stack>
    )
}

List.propTypes = {
    campaignFiles: PropTypes.arrayOf(PropTypes.instanceOf(DtoCampaignFile)),
    setPanel: PropTypes.func,
    setFile: PropTypes.func,
}

const keysAnalysis = ['qualitometer', 'id', 'sample', 'operation', 'sampleDate', 'analysisDate', 'parameter', 'unit', 'result', 'remark', 'support', 'localization', 'lq', 'ld', 'saturationThreshold', 'qualification', 'status', 'fraction', 'labo', 'jobexecutionid', 'importDate', 'updateDate', 'updateLogin', 'numSampling', 'errors']
const specificFormat = { errors: v => v ? v.split(',') : [] }

const Detail = ({
    file = {},
    setPanel = () => { },
    setFile = () => { },
    controlObject = {},
}) => {
    const [controlState, setControlState] = useState('IDLE')
    const {
        controllerRef,
        initController,
    } = useAbortController()

    const [analysis, setAnalysis] = useState([])
    const [selectedAnalysis, setSelectedAnalysis] = useState([])

    const {
        value: isEditMode,
        setFalse: onReadMode,
        setTrue: onEditMode,
    } = useBoolean(false)

    useActions(() => {
        if (isEditMode) {
            return {
                cancel: () => {
                    setSelectedAnalysis([])
                    onReadMode()
                },
            }
        }
        return {
            edit: onEditMode,
        }
    }, [isEditMode])

    useUpdateEffect(() => {
        setControlState('LOADING')

        if (controllerRef.current.signal.aborted) {
            initController()
        }

        const qualityFilter = {
            jobExecutionId: file.jobExecutionId,
        }
        AnalysisAction.getControledAnalysis(controlObject, qualityFilter, controllerRef.current.signal)
            .then((list = []) => {
                setAnalysis(list.map(a => arrayLightToObject(a, keysAnalysis, specificFormat)))
                setControlState('SUCCEEDED')
            })
            .catch(() => {})

        return () => controllerRef.current.abort()
    }, [controlObject, file.jobExecutionId])

    const formattedAnalysis = useMemo(() => {
        return analysis.map(a => ({ ...a, ...calculateThresholdsResult(a) }))
    }, [analysis])

    const undefinedConformity = useMemo(() => formattedAnalysis.filter(a => a.errors.includes('UNDEFINED_CONFORMITY')), [formattedAnalysis])
    const conformData = useMemo(() => formattedAnalysis.filter(a => !a.errors.length), [formattedAnalysis])
    const nonConformData = useMemo(() => formattedAnalysis.filter(a => a.errors.length && !a.errors.includes('UNDEFINED_CONFORMITY')), [formattedAnalysis])

    const onDelete = na => setAnalysis(pa => pa.filter(a => a.id !== na.id))
    const onUpdate = na => setAnalysis(pa => pa.map(a => a.id === na.id ? na : a))
    const onSelected = (ana, isCheck) => setSelectedAnalysis(ps => isCheck ? ps.filter(a => a.id !== ana.id) : [...ps, ana])
    const onAllSelected = (allAna, isCheck) => setSelectedAnalysis(ps => isCheck ? differenceBy(ps, allAna, 'id') : uniqBy([...ps, ...allAna], 'id'))

    return (
        <Card>
            <CardTitle
                title={`${file.nameFile} - ${getFullDate(file.date)}`}
                actions={[{
                    icon: 'keyboard_backspace',
                    onClick: () => {
                        setPanel(LIST)
                        setFile(undefined)
                    },
                }]}
            />
            <CardContent>
                {controlState === 'IDLE' && (
                    <MessageCard>{i18n.pleaseControl}</MessageCard>
                )}
                {controlState === 'LOADING' && (
                    <div style={{ padding: 10 }}>
                        <ProgressBar indeterminate withMessage />
                    </div>
                )}
                {controlState === 'SUCCEEDED' && (
                    <Grid2 container spacing={2} padding={1}>
                        {isEditMode && (
                            <Grid2 size={12}>
                                <CardUpdateAnalysis
                                    selectedAnalysis={selectedAnalysis}
                                    onUpdate={(updatedAnalysis) => {
                                        setSelectedAnalysis([])
                                        setAnalysis(pa => pa.map(a => updatedAnalysis.find(ua => ua.id === a.id) ?? a))
                                    }}
                                />
                            </Grid2>
                        )}
                        {nonConformData.length !== 0 && (
                            <Grid2 size={12}>
                                <ControlTable
                                    title={i18n.nonConformAnalysis}
                                    analysis={nonConformData}
                                    headers={HEADER_NON_CONFORM}
                                    defaultExpanded
                                    isEditMode={isEditMode}
                                    onDelete={onDelete}
                                    onUpdate={onUpdate}
                                    selectedAnalysis={selectedAnalysis}
                                    onSelected={onSelected}
                                    onAllSelected={onAllSelected}
                                />
                            </Grid2>
                        )}
                        {conformData.length !== 0 && (
                            <Grid2 size={12}>
                                <ControlTable
                                    title={i18n.conforms}
                                    analysis={conformData}
                                    headers={HEADER_CONFORM}
                                    isEditMode={isEditMode}
                                    onDelete={onDelete}
                                    onUpdate={onUpdate}
                                    selectedAnalysis={selectedAnalysis}
                                    onSelected={onSelected}
                                    onAllSelected={onAllSelected}
                                />
                            </Grid2>
                        )}
                        {undefinedConformity.length !== 0 && (
                            <Grid2 size={12}>
                                <ControlTable
                                    title={i18n.undefinedConformity}
                                    analysis={undefinedConformity}
                                    headers={HEADER_CONFORM}
                                    isEditMode={isEditMode}
                                    onDelete={onDelete}
                                    onUpdate={onUpdate}
                                    selectedAnalysis={selectedAnalysis}
                                    onSelected={onSelected}
                                    onAllSelected={onAllSelected}
                                />
                            </Grid2>
                        )}
                    </Grid2>
                )}
            </CardContent>
        </Card>
    )
}

Detail.propTypes = {
    file: PropTypes.instanceOf(DtoCampaignFile),
    setPanel: PropTypes.func,
    setFile: PropTypes.func,
    controlObject: PropTypes.shape({
        conformitySandre: PropTypes.bool,
        outlier: PropTypes.bool,
        multiParam: PropTypes.bool,
        improbabilityThreshold: PropTypes.number,
        impossibilityThreshold: PropTypes.number,
    }),
}

const ExportModal = ({
    open = false,
    onClose = () => { },
    campaignFiles = [],
}) => {
    const dispatch = useDispatch()
    const {
        campaign,
    } = useSelector(store => ({
        campaign: store.CampaignReducer.campaign,
    }), shallowEqual)

    const onExport = (type) => {
        if (!campaignFiles.length) {
            return dispatch(ToastrAction.error(i18n.noDataToExport))
        }
        const data = campaignFiles.map(file => {
            const objExecution = { status: file.statusCode, date: file.date }
            const tooltipStatus = getExecStatusLabel(objExecution)
            return {
                fileLabel: file.nameFile,
                jobExecutionId: file.jobExecutionId,
                date: getFullDate(file.date),
                state: tooltipStatus,
                stations: file.nbStation,
                operations: file.nbOperation,
                analysis: file.nbAnalyse,
                parameters: file.nbParameter,
            }
        })
        const dataWithHeader = data.length ? [{ ...data[0], headers: Object.keys(data[0]) }, ...data.slice(1)] : []
        return dispatch(ExportAction.export(formatData(dataWithHeader), type, `${campaign.name} - ${i18n.file}`))
    }

    const tableExport = [{
        name: i18n.resultsTable,
        formats: [{
            type: i18n.excelFile,
            callback: () => onExport('xlsx'),
        }, {
            type: i18n.csvFile,
            callback: () => onExport('csv'),
        }],
    }]

    return (
        <ExportFileModal
            open={open}
            onClose={onClose}
            data={tableExport}
        />
    )
}

ExportModal.propTypes = {
    open: PropTypes.boolean,
    onClose: PropTypes.func,
    campaignFiles: PropTypes.arrayOf(PropTypes.instanceOf(DtoCampaignFile)),
}

const QualityCampaignFileApp = () => {
    const dispatch = useDispatch()
    const { id } = useParams()

    const {
        campaign,
        campaignFiles,
        qualitometers,
    } = useSelector(store => ({
        campaign: store.CampaignReducer.campaign,
        campaignFiles: store.CampaignReducer.campaignFiles,
        qualitometers: store.QualityReducer.qualitometersLight,
    }), shallowEqual)

    const [searchValue, setSearchValue] = useState('')
    const [searchStation, setSearchStation] = useState('')
    const [panel, setPanel] = useState(LIST)
    const [file, setFile] = useState()

    const [controlObject, setControlObject] = useState({})

    useTitle(() => [
        {
            title: i18n.quality,
            href: '/quality',
        },
        {
            title: i18n.campaigns,
            href: '/quality/campaign',
        },
        {
            title: campaign.name || id,
            href: `/quality/campaign/${id}/dashboard`,
        },
        {
            title: i18n.files,
            href: `/quality/campaign/${id}/file`,
        },
        ...(file ? [{
            title: file.nameFile,
            href: `/quality/campaign/${id}/file`,
        }] : []),
    ], [campaign, file])

    const {
        progress,
        isLoaded,
    } = useProgressDispatch(() => {
        return [
            dispatch(QualityAction.fetchQualitometersLight()),
            dispatch(QualityAction.fetchStatus()),
            dispatch(QualityAction.fetchQualifications()),
            dispatch(FractionAction.fetchFractions()),
            dispatch(SupportAction.fetchSupports()),
            dispatch(UnitAction.fetchUnits()),
            dispatch(OperationAction.fetchRemarks()),
            dispatch(QualityIntegrationOverviewAction.fetchAnalyseErrorTypes()),
            dispatch(CampaignAction.fetchCampaignFiles(id)),
        ]
    }, [])

    const filesFormat = useMemo(() => campaignFiles.map(f => {
        const labelSearch = f.qualitometers.map(code => {
            const qualito = qualitometers.find(q => q.code === code)
            return qualito && `${code}${qualito.name || ''}` || ''
        }).join('')
        return {
            ...f,
            stationSearch: searchAllCharacters(labelSearch),
        }
    }), [campaignFiles, qualitometers])

    const filesFiltered = useMemo(() => {
        const searchValueFormat = searchAllCharacters(searchValue)
        const searchStationFormat = searchAllCharacters(searchStation)
        const searchFilter = hasValue(searchValueFormat) ? filesFormat.filter(({ nameFile }) => searchAllCharacters(nameFile).includes(searchValueFormat)) : filesFormat
        return hasValue(searchStationFormat) ? searchFilter.filter(f => f.stationSearch.includes(searchStationFormat)) : searchFilter
    }, [filesFormat, searchStation, searchValue])

    return (
        <Grid2 container sx={{ padding: '5 10' }} spacing={1}>
            <Grid2 size={12}>
                {panel === LIST && (
                    <Card>
                        <CardContent>
                            <Grid2 container sx={{ padding: '10' }} spacing={2} alignItems='center'>
                                <Grid2 size={3}>
                                    <Input
                                        title={i18n.research}
                                        value={searchValue}
                                        onChange={setSearchValue}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <Input
                                        title={i18n.station}
                                        value={searchStation}
                                        onChange={setSearchStation}
                                    />
                                </Grid2>
                            </Grid2>
                        </CardContent>
                    </Card>
                )}
                {panel === DETAIL && (
                    <ControlForm onValidate={setControlObject}/>
                )}
            </Grid2>
            <Grid2 size={12}>
                {
                    !isLoaded && (
                        <Card>
                            <CardContent>
                                <ProgressBar withMessage progress={progress} />
                            </CardContent>
                        </Card>
                    )
                }
                {
                    isLoaded && panel === LIST && (
                        <List
                            campaignFiles={filesFiltered}
                            setPanel={setPanel}
                            setFile={setFile}
                        />
                    )
                }
                {
                    isLoaded && panel === DETAIL && (
                        <Detail
                            file={file}
                            setPanel={setPanel}
                            setFile={setFile}
                            controlObject={controlObject}
                        />
                    )
                }
            </Grid2>
        </Grid2>
    )
}

export default QualityCampaignFileApp